import { useState } from "react";
import { mockServices } from "../../../mocks/services";

export default function ServiceManagement() {
  const [activeCategory, setActiveCategory] = useState<number | null>(null);
  const [editingId, setEditingId] = useState<number | null>(null);
  const [prices, setPrices] = useState<Record<number, number>>({});

  const displayed = activeCategory
    ? mockServices.filter((c) => c.id === activeCategory)
    : mockServices;

  const totalServices = mockServices.reduce((acc, c) => acc + c.services.length, 0);
  const totalBookings = mockServices.reduce(
    (acc, c) => acc + c.services.reduce((a, s) => a + s.bookings, 0),
    0
  );

  return (
    <div className="p-6 space-y-5 overflow-y-auto h-full">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            ✦ Hizmet Yönetimi
          </h1>
          <p className="text-sm mt-1" style={{ color: "rgba(255,255,255,0.4)" }}>
            {totalServices} hizmet · {totalBookings} toplam rezervasyon
          </p>
        </div>
        <button
          className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium cursor-pointer transition-all hover:opacity-90 whitespace-nowrap"
          style={{ background: "linear-gradient(135deg, #d4af37, #f59e0b)", color: "#1a1535" }}
        >
          <i className="ri-add-line" />
          Hizmet Ekle
        </button>
      </div>

      {/* Category Filter */}
      <div className="flex items-center gap-2 flex-wrap">
        <button
          onClick={() => setActiveCategory(null)}
          className="px-4 py-2 rounded-xl text-sm font-medium cursor-pointer transition-all whitespace-nowrap"
          style={
            activeCategory === null
              ? { background: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)" }
              : { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.65)", border: "1px solid rgba(255,255,255,0.12)" }
          }
        >
          Tümü
        </button>
        {mockServices.map((cat) => (
          <button
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium cursor-pointer transition-all whitespace-nowrap"
            style={
              activeCategory === cat.id
                ? { background: `${cat.categoryColor}30`, color: cat.categoryColor, border: `1px solid ${cat.categoryColor}60` }
                : { background: "rgba(255,255,255,0.06)", color: "rgba(255,255,255,0.65)", border: "1px solid rgba(255,255,255,0.12)" }
            }
          >
            <i className={`${cat.categoryIcon} text-sm`} />
            {cat.category}
          </button>
        ))}
      </div>

      {/* Service Categories */}
      <div className="space-y-5">
        {displayed.map((cat) => (
          <div key={cat.id} className="rounded-2xl overflow-hidden"
            style={{ border: `1px solid ${cat.categoryColor}38` }}>
            {/* Category Header */}
            <div className="px-5 py-4 flex items-center gap-3"
              style={{ background: `${cat.categoryColor}18`, borderBottom: `1px solid ${cat.categoryColor}30` }}>
              <div className="w-9 h-9 rounded-xl flex items-center justify-center"
                style={{ background: `${cat.categoryColor}30` }}>
                <i className={`${cat.categoryIcon} text-base`} style={{ color: cat.categoryColor }} />
              </div>
              <div>
                <h2 className="font-semibold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {cat.category}
                </h2>
                <p className="text-xs font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>
                  {cat.services.length} hizmet
                </p>
              </div>
              <div className="ml-auto flex items-center gap-3">
                <span className="text-xs px-2.5 py-1 rounded-full font-medium"
                  style={{ background: `${cat.categoryColor}25`, color: cat.categoryColor }}>
                  {cat.services.reduce((a, s) => a + s.bookings, 0)} rezervasyon
                </span>
              </div>
            </div>

            {/* Services Grid */}
            <div className="p-4 grid grid-cols-2 gap-3" style={{ background: "rgba(0,0,0,0.2)" }}>
              {cat.services.map((svc) => (
                <div key={svc.id}
                  className="rounded-xl p-4 relative transition-all hover:bg-white/[0.06]"
                  style={{
                    background: "rgba(255,255,255,0.07)",
                    border: `1px solid ${svc.active ? "rgba(255,255,255,0.15)" : "rgba(255,255,255,0.07)"}`,
                    opacity: svc.active ? 1 : 0.6,
                  }}>
                  <div className="flex items-start justify-between mb-2">
                    <div>
                      <h3 className="text-sm font-semibold text-white">{svc.name}</h3>
                      <p className="text-xs mt-0.5 font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>
                        {svc.duration}
                      </p>
                    </div>
                    <div className="flex items-center gap-1">
                      {!svc.active && (
                        <span className="text-xs px-2 py-0.5 rounded-full" style={{ background: "rgba(239,68,68,0.25)", color: "#fca5a5" }}>
                          Pasif
                        </span>
                      )}
                      <button
                        onClick={() => setEditingId(editingId === svc.id ? null : svc.id)}
                        className="w-7 h-7 rounded-lg flex items-center justify-center cursor-pointer transition-all hover:bg-white/10"
                        style={{ color: "rgba(255,255,255,0.6)" }}>
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-edit-line text-sm" />
                        </div>
                      </button>
                    </div>
                  </div>

                  {editingId === svc.id ? (
                    <div className="mt-2 flex items-center gap-2">
                      <input
                        type="number"
                        defaultValue={prices[svc.id] ?? svc.price}
                        onChange={(e) => setPrices((prev) => ({ ...prev, [svc.id]: Number(e.target.value) }))}
                        className="flex-1 px-3 py-1.5 rounded-lg text-sm text-white outline-none"
                        style={{ background: "rgba(255,255,255,0.12)", border: "1px solid rgba(212,175,55,0.45)", fontFamily: "monospace" }}
                      />
                      <span className="text-xs font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>₺</span>
                      <button
                        onClick={() => setEditingId(null)}
                        className="px-3 py-1.5 rounded-lg text-xs cursor-pointer whitespace-nowrap font-medium"
                        style={{ background: "rgba(212,175,55,0.25)", color: "#fde68a" }}>
                        Kaydet
                      </button>
                    </div>
                  ) : (
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-lg font-bold" style={{ color: cat.categoryColor, fontFamily: "'Playfair Display', serif" }}>
                        ₺{(prices[svc.id] ?? svc.price).toLocaleString("tr-TR")}
                      </span>
                      <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: "rgba(255,255,255,0.1)", color: "rgba(255,255,255,0.65)" }}>
                        {svc.bookings} rezerv.
                      </span>
                    </div>
                  )}

                  <div className="mt-2 pt-2 flex items-center gap-2" style={{ borderTop: "1px solid rgba(255,255,255,0.1)" }}>
                    <i className="ri-time-line text-xs" style={{ color: "rgba(255,255,255,0.5)" }} />
                    <span className="text-xs font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>
                      {svc.deliveryTime}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center gap-2">
                    <i className="ri-calendar-check-line text-xs" style={{ color: "rgba(255,255,255,0.5)" }} />
                    <span className="text-xs font-medium" style={{ color: "rgba(255,255,255,0.6)" }}>
                      {svc.suitableDays}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
